import { React, useState, useEffect, useCallback, useContext } from "react";
import Button from "@mui/material/Button";
import { DataGrid, GridActionsCellItem, GridToolbar } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import axios from "axios";
import Swal from "sweetalert2";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import MenuUpdateModal from "../../../../modal/PC/system/MenuUpdateModal";
import styled from "styled-components";
import Select from 'react-select';
import { AppContext } from '../../../../AppStore';
import Moment from 'moment';
import "moment/locale/ko";
import { useNavigate, useLocation } from "react-router-dom";

const Menu = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [menuOption, setMenuOption] = useState([]);
    const [menuTypeOption, setMenuTypeOption] = useState([]);
    const [originRows, setOriginRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [keyword, setKeyword] = useState({
        menu_id: 0,
        menu_type:''
    });
    const [isUpdateModalOpen, setUpdateModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [selectMenuID, setSelectMenuID] = useState('');
    const [menuModalFullOption, setMenuModalFullOption] = useState([]);
    const [menuModalOption, setMenuModalOption] = useState([]);
    const [zeroMaxSort, setZeroMaxSort] = useState(0);
    const modal_select_array = []

    // Grid정의
    const handleSetting = () => {
        setColumns([
            {
                field: 'updated',
                headerName: '수정',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<EditIcon color="primary" />} onClick={() => {UpdateClick(params)}} label="Edit" disabled="" />
                ],
                headerAlign: 'center', 
                align:'center'
            },
            { field: 'id', headerName: '화면ID', width: 0, headerAlign: 'center', align:'center' },
            { field: 'menu_name', headerName: '화면명', width: 250, headerAlign: 'center', align:'left' },
            { field: 'upper_menu_id', headerName: '상위화면ID', width: 0, headerAlign: 'center', align:'center' },
            { field: 'upper_menu_name', headerName: '상위화면명', width: 250, headerAlign: 'center', align:'left' },
            { field: 'menu_nav_exposure_order', headerName: '화면정렬순서', width: 140, headerAlign: 'center', align:'right' },
            { field: 'menu_ui_yn', headerName: '화면UI여부', width: 80, headerAlign: 'center', align:'center' },
            { field: 'menu_solution_yn', headerName: '화면솔루션여부', width: 80, headerAlign: 'center', align:'center' },
            { field: 'menu_type', headerName: '화면유형', width: 80, headerAlign: 'center', align:'center' },
            { field: 'menu_type_name', headerName: '화면유형', width: 120, headerAlign: 'center', align:'center' },
            { field: 'menu_type_detail', headerName: '화면유형상세', width: 80, headerAlign: 'center', align:'center' },
            { field: 'reg_user_id', headerName: 'reg_user_id', width: 0, headerAlign: 'center' },
            { field: 'reg_user_name', headerName: '등록자', width: 120, headerAlign: 'center', align:'center' },
            { field: 'reg_datetime', headerName: '등록일시', width: 200, headerAlign: 'center', align:'center' },
            { field: 'update_user_id', headerName: 'update_user_id', width: 0, headerAlign: 'center' },
            { field: 'update_user_name', headerName: '수정자', width: 120, headerAlign: 'center', align:'center' },
            { field: 'update_datetime', headerName: '수정일시', width: 200, headerAlign: 'center', align:'center' },
        ]);
    }

    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false,
        menu_name: true,
        upper_menu_id: false,
        upper_menu_name: true,
        menu_nav_exposure_order: true,
        menu_ui_yn: false,
        menu_solution_yn: false,
        menu_type: false,
        menu_type_name: true,
        menu_type_detail: false,
        reg_user_id: false,
        reg_user_name: true,
        reg_datetime: true,
        update_user_id: false,
        update_user_name: true,
        update_datetime: true,
        deleted: true,
        updated: true
    });

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        console.log(accessList)
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleView();
        }
    }, [keyword]);

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSetting();
            handleInitSelect();
            handleInit();
            handleView();
        }
    }, [MenuID]);

    // Grid 데이터 조회
    const handleView = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);
        
        axios.get('/api/p/Menu/List',
            {
            params : {
                search_menu_id: keyword.menu_id,
                search_menu_type: keyword.menu_type,
            }
          },
          { withCredentials: true }
        )
        .then((response) => {
            const PermissionMap = {};
            response.data.forEach(row => {
                if (!PermissionMap[row.menu_id]) {
                    PermissionMap[row.menu_id] = [row.reg_user_id, row.update_user_id].includes(Number(localStorage.getItem('user_id')));
                }
            });
            
            const array = response.data.map((item, index) => ({
                id: item.menu_id,
                menu_name: item.menu_name,
                upper_menu_id: item.upper_menu_id,
                upper_menu_name: item.upper_menu_name,
                menu_nav_exposure_order: item.menu_nav_exposure_order,
                menu_ui_yn: item.menu_ui_yn,
                menu_solution_yn: item.menu_solution_yn,
                menu_type: item.menu_type,
                menu_type_name: item.menu_type_name,
                menu_type_detail: item.menu_type_detail,
                reg_user_id: item.reg_user_id,
                reg_user_name: item.reg_user_name,
                reg_datetime: (item.reg_datetime === undefined?'':Moment(item.reg_datetime).format('YYYY-MM-DD HH:mm:ss')),
                update_user_id: item.update_user_id,
                update_user_name: item.update_user_name,
                update_datetime: (item.update_datetime === undefined?'':Moment(item.update_datetime).format('YYYY-MM-DD HH:mm:ss')),
                update_flag: PermissionMap[item.menu_id] ? 'Y' : 'N'
            }));
            setOriginRows(response.data);
            setRows(array);

            // 같은 menu 정보는 이곳에서 같이 생성
            const modal_full_array = response.data.map((item, index) => ({
                id: item.menu_id,
                menu_name: item.menu_name,
                upper_menu_id: item.upper_menu_id,
                upper_menu_name: item.upper_menu_name,
                menu_sort: item.menu_nav_exposure_order,
            }));

            response.data.map((item,index) =>{
                if(item.upper_menu_id == 0 && item.menu_ui_yn == 'N'){
                    modal_select_array.push({ value: item.menu_id, label: item.menu_name, maxsort: item.max_sort })
                }
            })

            let zero_max_sort = 1;
            response.data.map((item,index) =>{
                if(item.upper_menu_id == 0 && item.menu_ui_yn == 'N'){
                    zero_max_sort++
                }
            })
            setZeroMaxSort(zero_max_sort)
            
            modal_select_array.unshift({ value: 0, label : '상위화면', maxsort:zero_max_sort});
            setMenuModalFullOption(modal_full_array);
            setMenuModalOption(modal_select_array);
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false); 
        })

    }

    const handleInitSelect = () => {
        //상위화면
        setMenuOption(modal_select_array)

        //화면유형
        var array = [
            {value:0, label:'화면유형'}
            ,{value:'P', label:'PC'}
            ,{value:'T', label:'Tablet'}
            ,{value:'M', label:'Mobile'}
        ];
        setMenuTypeOption(array);
    }

    const handleInit = () => {
        setKeyword({
            menu_search_name: '',
        })
        
        // Hide컬럼 숨기기.
        setColumnVisibilityModel({
            id: false,
            menu_name: true,
            upper_menu_id: false,
            upper_menu_name: true,
            menu_nav_exposure_order: true,
            menu_ui_yn: false,
            menu_solution_yn: false,
            menu_type: false,
            menu_type_name: true,
            menu_type_detail: false,
            reg_user_id: false,
            reg_user_name: true,
            reg_datetime: true,
            update_user_id: false,
            update_user_name: true,
            update_datetime: true,
            deleted: true,
            updated: true
        });
    };

    const UpdateClick = (object) => {
        setUpdateModalOpen(true);
        setModalTitle('화면 수정');
        setSelectMenuID(object.row.id);
    };

    const onSelectChange = (type, value) => {
        const nextKeyword = {
            ...keyword,
            [type] : value
        };
        setKeyword(nextKeyword);
    };

    const onChange = (e)=>{
        const {name, value} = e.target;
        const nextKeyword = {
            ...keyword,
            [name]: value, 
        };
        setKeyword(nextKeyword);
    };
    
    const handleExcel = () => {
        var filename = '화면관리'
        axios.get('/api/p/Menu/Excel',
        {   
            params : { search_menu_id: keyword.menu_id, search_menu_type: keyword.menu_type, file_name: filename },
            responseType:'blob'
        },
        { withCredentials: true })
        .then(function (response) {
            
            if(response.status === 200){
                filename = filename + ' ' + appStore.YYYY_MM_DD_HH_MI_SS();
                const link = document.createElement('a');
                link.href = URL.createObjectURL(response.data);
                link.setAttribute('download', filename+'.xlsx');
                document.body.appendChild(link);
                link.click();
            }
        })
        .catch(function (error) {
            appStore.capture();
        })
    };

    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox">
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                        <div className="menu-button">
                        <Button 
                            onClick={ handleExcel }
                            className="btn-p"
                            sx={{  
                                m: 1, 
                                fontSize: 15, 
                                color: "white", 
                                borderColor: "#00AC47", 
                                backgroundColor: "#00AC47",
                                ":hover": { boxShadow: "2px 2px 2px #00AC47" , backgroundColor: "#00AC47", borderColor: "#00AC47"}
                            }} 
                            variant="outlined">
                            엑셀
                        </Button>
                        <Button 
                            onClick={ handleInit }
                            className="btn-p"
                            sx={{  
                                m: 1, 
                                fontSize: 15, 
                                color: "white", 
                                borderColor: "black", 
                                backgroundColor: "black",
                                ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                            }} 
                            variant="outlined">
                            초기화
                        </Button>
                        <Button 
                            onClick={ handleView }
                            className="btn-p"
                            sx={{  
                                m: 1, 
                                fontSize: 15, 
                                color: "white", 
                                borderColor: "#3D63AE", 
                                backgroundColor: "#3D63AE",
                                ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                            }} 
                            variant="outlined">
                            조회
                        </Button>
                        </div>
                </div>
                <div className="menu-keyword">
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title">
                            상위화면
                        </div>
                        <div className="menu-keyword-sub-keyword">
                            <Select className="menu-keyword-sub-keyword-select" placeholder="상위화면" onChange={(e) => onSelectChange('menu_id',e.value)} value={menuOption.filter(function (option) { return option.value === keyword.menu_id;  })} options={menuOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                    </div>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title">
                            화면유형
                        </div>
                        <div className="menu-keyword-sub-keyword">
                            <Select className="menu-keyword-sub-keyword-select" placeholder="화면유형" onChange={(e) => onSelectChange('menu_type',e.value)} value={menuTypeOption.filter(function (option) { return option.value === keyword.menu_type;  })} options={menuTypeOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                    </div>
                </div>
            </div>
            { MenuID !== '0'? 
            <div className="grid">
                <div className="grid_sub" style={ { width: '100%', fontSize: '17px' } }>
                    <DataGrid
                        className="grid_main"
                        rows={rows}
                        columns={columns}
                        slots={{
                            noRowsOverlay: GridNoRow,
                        }}
                        columnVisibilityModel={columnVisibilityModel}
                        AlternatingRowBackground="LavenderBlush"
                        rowsPerPageOptions={[20, 50, 100]}
                    />
                    {isUpdateModalOpen && MenuUpdateYN === 'Y' && (
                        <MenuUpdateModal
                        onClose={() => {
                            setUpdateModalOpen(false);
                        }}
                        title={modalTitle}
                        id={selectMenuID}
                        originRows={originRows.filter(row => String(row.menu_id) === String(selectMenuID))}
                        handleView={handleView}
                        menuModalFullOption={menuModalFullOption}
                        menuModalOption={menuModalOption}
                        />
                    )}
                </div>
            </div>
            : "" }
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;

export default Menu;
